import { useField } from 'formik';
import { InputGroup, Form, Col } from 'react-bootstrap';
import Label from '../Label';
import ErrorMessage from '../ErrorMessage';

export default function DatePicker({
  label = '',
  hasValidation = true,
  maxLength = 100,
  placeholder = '',
  containerClassName = '',
  labelClassName = '',
  ...props
}) {
  const [field, meta] = useField(props);

  const { error, touched } = meta;

  return (
    <InputGroup hasValidation={hasValidation} className="Input my-2">
      <Label label={label} className={labelClassName} />

      <Col xs={12} className={containerClassName}>
        <Form.Control
          type="date"
          {...props}
          {...field}
          placeholder={placeholder || label}
          maxLength={maxLength}
          isInvalid={touched && error}
        />
      </Col>

      <ErrorMessage {...meta} className="text-right" />
    </InputGroup>
  );
}
